import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpmachinecredential1postPostScreenTruthMachineCredentialsResponseSchema = jsonObject
export type tcpmachinecredential1postPostScreenTruthMachineCredentialsResponse = z.infer<typeof tcpmachinecredential1postPostScreenTruthMachineCredentialsResponseSchema>
